import { render, staticRenderFns } from "./Temperature.vue?vue&type=template&id=42733c08&scoped=true"
import script from "./Temperature.vue?vue&type=script&lang=js"
export * from "./Temperature.vue?vue&type=script&lang=js"
import style0 from "./Temperature.vue?vue&type=style&index=0&id=42733c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42733c08",
  null
  
)

export default component.exports